export default __webpack_public_path__ + "static/media/operario.d98a41a3.jpg";